
import React from 'react';
import { useContentManagement } from '@/hooks/useContentManagement';
import ContentStats from './ContentStats';
import ContentFiltersSection from './ContentFiltersSection';
import ContentTableSection from './ContentTableSection';
import ContentLoadingState from './ContentLoadingState';

const ContentManagement: React.FC = () => {
  const {
    searchTerm,
    statusFilter,
    disciplineFilter,
    typeFilter,
    allNodes,
    filteredNodes,
    disciplines,
    isLoading,
    setSearchTerm,
    setStatusFilter,
    setDisciplineFilter,
    setTypeFilter,
    handleFeatureToggle,
    handleStatusChange,
    handleDelete,
    handleClearFilters,
  } = useContentManagement();

  if (isLoading) {
    return <ContentLoadingState />;
  }

  return (
    <div className="space-y-6">
      <ContentStats nodes={allNodes || []} />
      
      <ContentFiltersSection
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        statusFilter={statusFilter}
        setStatusFilter={setStatusFilter}
        disciplineFilter={disciplineFilter}
        setDisciplineFilter={setDisciplineFilter}
        typeFilter={typeFilter}
        setTypeFilter={setTypeFilter}
        onClearFilters={handleClearFilters}
      />

      <ContentTableSection
        nodes={filteredNodes || []}
        disciplines={disciplines || []}
        onFeatureToggle={handleFeatureToggle}
        onStatusChange={handleStatusChange}
        onDelete={handleDelete}
      />
    </div>
  );
};

export default ContentManagement;
